$(function () {
  var noColumns = 3;
  var noRows = 2;
  if (breakpoint.value === 'xs') {
    noColumns = 1;
    noRows = 3;
  } else if (breakpoint.value === 'sm') {
    noColumns = 2;
    noRows = 2;
  }
  $(".testimonialsComponent-item").hide();
  $(".testimonialsComponent-item:hidden").slice(0, noColumns * noRows).show();
  hideButtonIfAllItemsAreVisible();
  $('.testimonialsComponent-btnLoadMore').on('click', function () {
    $(".testimonialsComponent-item:hidden").slice(0, noColumns * noRows).show();
    hideButtonIfAllItemsAreVisible();
  });
  function hideButtonIfAllItemsAreVisible() {
    if ($(".testimonialsComponent-item:hidden").length === 0) {
      $('.testimonialsComponent-btnLoadMore').hide();
    }
  }
});